'use client';

import { useEffect, useState } from 'react';

interface StarPosition {
	top: number;
	left: number;
	size: number;
	duration: number;
	delay: number;
}

function StarBackgroundContent() {
	const [stars, setStars] = useState<StarPosition[]>([]);
	const [shootingStars, setShootingStars] = useState<
		{ top: number; left: number; delay: number }[]
	>([]);

	useEffect(() => {
		// Generate stars with random positions and sizes
		// const generateStars = () =>
		// 	Array.from({ length: 50 }).map(() => ({
		// 		top: Math.random() * 100,
		// 		left: Math.random() * 100,
		// 		size: 0.5 + Math.random() * 2,
		// 		duration: 2 + Math.random() * 4,
		// 		delay: Math.random() * 5,
		// 	}));
		// Generate random shooting stars
		// const generateShootingStars = () =>
		// 	Array.from({ length: 4 }).map(() => ({
		// 		top: Math.random() * 50, // Restrict shooting stars to the upper part of the screen
		// 		left: Math.random() * 100,
		// 		delay: Math.random() * 6, // Staggered delays
		// 	}));
		// setStars(generateStars());
		// setShootingStars(generateShootingStars());
		// Update shooting stars periodically
		// const interval = setInterval(() => {
		// 	setShootingStars(generateShootingStars());
		// }, 4000);
		// return () => clearInterval(interval);
	}, []);

	return (
		<div className="pointer-events-none fixed inset-0 z-0">
			{/* Static Stars */}
			{stars.map((star, i) => (
				<div
					key={`star-${i}`}
					className="star absolute"
					style={{
						top: `${star.top}%`,
						left: `${star.left}%`,
						width: `${star.size}px`,
						height: `${star.size}px`,
						animationDuration: `${star.duration}s`,
						animationDelay: `${star.delay}s`,
					}}
				/>
			))}
			{/* Shooting Stars */}
			{shootingStars.map((star, i) => (
				<div
					key={`shooting-star-${i}`}
					className="shooting-star absolute"
					style={{
						top: `${star.top}%`,
						left: `${star.left}%`,
						animationDelay: `${star.delay}s`,
					}}
				/>
			))}
		</div>
	);
}

export default function StarBackground() {
	return <StarBackgroundContent />;
}
